export const youtube = 'https://www.youtube.com/@staticbuzz-f1f'
export const instagram = 'https://www.instagram.com/static_buzz_/'
export const bandcamp = 'https://duckett.bandcamp.com/'
export const soundcloud = 'https://soundcloud.com/simon-duckett'
export const website = 'https://staticbuzz.io'
export const ambientloops = 'https://duckett.bandcamp.com/album/ambient-loops-vol-1'